const listenForWhitepaperForm2024Submit = require("./listenForWhitepaperForm2024Submit");
const initWhitepaper2024ReturningUserVisibility = require("./initWhitepaper2024ReturningUserVisibility");
const listenForWhitepaper2024ReturningUserShowContentButtonClick = require("./listenForWhitepaper2024ReturningUserShowContentButtonClick");
const listenForWhitepaperForm2024NotYouButtonClick = require('./listenForWhitepaperForm2024NotYouButtonClick');
const initWhitepaper2024ZoomInfoAutofillFallback = require("./initZoomInfoAutofillFallback");
const Form_init = require("../../Form_init");

/**
 * @param onSubmit {(form: HTMLFormElement) => void}
 * @param onShowContentClicked {() => void}
 * @param onNotYouClicked {() => void}
 * @return {void}
 */
module.exports = function initWhitepaper2024(onSubmit, onShowContentClicked, onNotYouClicked) {
    initWhitepaper2024ReturningUserVisibility();

    listenForWhitepaper2024ReturningUserShowContentButtonClick(onShowContentClicked);

    listenForWhitepaperForm2024NotYouButtonClick(onNotYouClicked);

    listenForWhitepaperForm2024Submit(onSubmit);

    initWhitepaper2024ZoomInfoAutofillFallback();

    document.querySelectorAll('[data-component="whitepaper_form_form"]').forEach(form => {
        if (form instanceof HTMLFormElement) {
            Form_init(form);
        }
    });
}
